import React, { Fragment, useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Dialog, Transition } from "@headlessui/react";
import moment from "moment";
//images
import CLOSE from "../../assets/images/icons/close.svg";
import { ReactComponent as SHIPPERS } from "../../assets/images/icons/shippers-red.svg";
//Api
import { filterPublicShippers } from "../../redux/publicShippers/publicShippersActions";
import { storeCurrentShipper } from "../../redux/publicShippers/publicShippersActions";
import { isAuthenticatedUser } from "../../utils/Auth";
import {
  storePublicCartProducts,
  // editCart,
  showMyCart,
} from "../../redux/cart/cartAction";

export function SelectShipperModal(props) {
  const { setCurrentShipper, user, currentAddress, currentShipper } = props;
  const dispatch = useDispatch();
  const isLoggedIn = isAuthenticatedUser();
  const [selected, setSelected] = useState({});
  const { filterPublicShippersData } = useSelector(
    (state) => state.publicShippers
  );

  useEffect(() => {
    // Fetch shippers for both logged-in and guest users
    dispatch(
      filterPublicShippers({
        date: moment(new Date()).format("YYYY-MM-DD HH:mm"),
        pagination: 0,
      })
    );
    // eslint-disable-next-line
  }, []);

  // Set initial selected shipper when modal opens
  useEffect(() => {
    if (currentShipper?.id) {
      setSelected(currentShipper);
    }
  }, [currentShipper, props.show]);

  const handleSubmit = async () => {
    setCurrentShipper(selected);
    dispatch(storeCurrentShipper(selected));
    
    // Only call authenticated APIs if user is logged in
    if (isLoggedIn && user?.id) {
      try {
        const response = await dispatch(
          storePublicCartProducts({ user_id: user?.id, shipper_id: selected?.id })
        );

        if (response?.status_code === 200) {
          if (currentAddress?.length > 0) {
            dispatch(
              showMyCart({
                shipper_id: selected?.id,
                address_id: currentAddress?.[0]?.id,
              })
            );
          } else {
            dispatch(showMyCart({ shipper_id: selected?.id }));
          }
        }
      } catch (error) {
        console.log("Error updating cart with shipper:", error);
      }
    }
    
    props.onClose();
  };

  return (
    <div data-test="addressModal">
      <Transition show={props.show} as={Fragment}>
        <Dialog as="div" className="relative z-10" onClose={props.onClose}>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
          </Transition.Child>

          <div className="fixed z-10 inset-0 overflow-y-auto">
            <div className="flex items-center sm:items-center justify-center min-h-full p-4 text-center sm:p-0">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                enterTo="opacity-100 translate-y-0 sm:scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              >
                <Dialog.Panel className="relative w-[600px] bg-white dark:bg-[#121212] rounded-3xl px-4 pt-5 pb-4 max-h-[90vh] h-full overflow-scroll shadow-xl transform transition-all sm:my-10 sm:max-w-lg sm:w-full  sm:p-8">
                  <div className="sm:block absolute top-1 sm:top-3 right-4 pt-4 pr-4">
                    <button
                      type="button"
                      className="bg-[#ffeae5] rounded-3xl p-2 sm:p-3 outline-none"
                      onClick={props.onClose}
                    >
                      <span className="sr-only">Close</span>
                      <img
                        src={CLOSE}
                        alt="close"
                        className=" w-3 h-3 sm:w-4 sm:h-4"
                      />
                    </button>
                  </div>
                  <div className="sm:flex">
                    <div className="text-left sm:mt-2">
                      <Dialog.Title
                        as="h3"
                        className="text-xl font-medium text-black dark:text-white"
                      >
                        Change My Shipper
                      </Dialog.Title>
                    </div>
                  </div>
                  <div className="mt-5 sm:mt-4">
                    <div className="mt-4 border-b-2 "></div>
                    <div className="mt-8">
                      <ul>
                        {/* If there are multiple shipper, give room to change selected address */}
                        {filterPublicShippersData?.length > 0 ? (
                          <div>
                            {/* {filterPublicShippersData?.length > 0 &&
                              filterPublicShippersData?.flatMap((shipper) =>
                                shipper?.base_fees_by_delivery_mode.map(
                                  (mode) => (
                                    <li
                                      className="bg-white dark:bg-[#121212] border-b hover:bg-gray-100 group hover:shadow"
                                      key={`${shipper.id}-${mode.title}-${mode.category}`}
                                    >
                                      <div className="ml-3 flex justify-between text-left items-center mt-6 mb-4">
                                        <label
                                          htmlFor={`shipper-radio-${shipper.id}`}
                                        >
                                          <div className="flex items-start">
                                            <SHIPPERS
                                              className={
                                                "text-gray-400 group-hover:text-gray-500 mr-3 flex-shrink-0 h-[40px] w-[40px]"
                                              }
                                              aria-hidden="true"
                                            />
                                            <div className="ml-3">
                                              <p className="font-medium text-lg">
                                                {shipper?.name}
                                              </p>
                                              <p className="text-sm text-gray-400 font-normal">
                                                {mode.title}
                                              </p>
                                            </div>
                                          </div>
                                        </label>

                                        <input
                                          id={`shipper-radio-${shipper.id}`}
                                          name="shipper-radio-group"
                                          type={"radio"}
                                          className="w-6 h-6 text-primary bg-white dark:bg-[#121212] border-primary focus:ring-primary"
                                          onChange={() => setSelected(shipper)}
                                        />
                                      </div>
                                    </li>
                                  )
                                )
                              )} mt-6 mb-4*/}
                            {filterPublicShippersData?.length > 0 &&
                              filterPublicShippersData?.map((shipper) => (
                                <li
                                  className={`border-b py-4 hover:bg-gray-100 group hover:shadow ${
                                    selected?.id === shipper?.id
                                      ? "bg-red-50 dark:bg-red-900/20"
                                      : "bg-white dark:bg-[#121212]"
                                  }`}
                                  key={`${shipper.id}`}
                                >
                                  <div className="ml-3 flex justify-between text-left items-center">
                                    <label
                                      htmlFor={`shipper-radio-${shipper.id}`}
                                      className="cursor-pointer flex-1"
                                    >
                                      <div className="flex items-center">
                                        <SHIPPERS
                                          className={`mr-3 flex-shrink-0 h-[40px] w-[40px] ${
                                            selected?.id === shipper?.id
                                              ? "text-primary"
                                              : "text-gray-400 group-hover:text-gray-500"
                                          }`}
                                          aria-hidden="true"
                                        />
                                        <div className="ml-3">
                                          <p
                                            className={`font-medium text-lg ${
                                              selected?.id === shipper?.id
                                                ? "text-primary"
                                                : ""
                                            }`}
                                          >
                                            {shipper?.name}
                                          </p>
                                          {/* <p className="text-sm text-gray-400 font-normal">
                                            {mode.title}
                                          </p> */}
                                        </div>
                                      </div>
                                    </label>

                                    <input
                                      id={`shipper-radio-${shipper.id}`}
                                      name="shipper-radio-group"
                                      type={"radio"}
                                      checked={selected?.id === shipper?.id}
                                      className="w-6 h-6 text-primary bg-white dark:bg-[#121212] border-primary focus:ring-primary cursor-pointer"
                                      onChange={() => setSelected(shipper)}
                                    />
                                  </div>
                                </li>
                              ))}
                          </div>
                        ) : (
                          <p>No shippers available at this time</p>
                        )}

                        {filterPublicShippersData?.length > 0 && (
                          <button
                            type="button"
                            className="mt-5 mb-6 sm:mb-6 w-full inline-flex justify-center h-14 rounded-md border border-transparent shadow-sm px-4 py-4 bg-primary text-base font-medium text-white hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500  sm:mt-6 sm:text-sm"
                            onClick={handleSubmit}
                          >
                            {"Continue"}
                          </button>
                        )}
                      </ul>
                    </div>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition>
    </div>
  );
}
